import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CreateOrEditManualRefund from './CreateOrEditManualRefund';
import { REFUND_MODAL_TYPE } from '@/utility';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  borderRadius: '8px',
};

const EditManualRefundModal = ({
  refund,
  onClose,
  reFetch,
  updateStatus,
  path,
}) => {
  return (
    refund && (
      <Modal open={!!refund} onClose={onClose}>
        <Box sx={modalStyle}>
          <CreateOrEditManualRefund
            refundModalType={
              path === 'edit-refund-approval'
                ? REFUND_MODAL_TYPE.APPROVALS
                : path === 'edit-refund'
                ? REFUND_MODAL_TYPE.REFUNDS_PAGE
                : REFUND_MODAL_TYPE.RESOLUTION_CENTER
            }
            refundId={refund?.id}
            updateStatus={updateStatus}
            onClose={async () => {
              await reFetch();
              onClose(false);
            }}
            path={path}
          />
        </Box>
      </Modal>
    )
  );
};

export default EditManualRefundModal;
